class ToastService {
  static containerId = 'toastContainer';
  
  static ensureContainerExists() {
    let container = document.getElementById(this.containerId);
    if (!container) {
      container = document.createElement('div');
      container.id = this.containerId;
      container.className = 'toast-container';
      document.body.appendChild(container);
    }
    return container;
  }
  
  static showToast(message, type = 'info', duration = 3000) {
    const container = this.ensureContainerExists();
    
    // Create toast element
    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.textContent = message;
    
    // Add to container
    container.appendChild(toast);
    
    // Animate in
    setTimeout(() => toast.classList.add('show'), 10);
    
    // Auto remove after duration
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        if (toast.parentNode === container) {
          container.removeChild(toast);
        }
      }, 300);
    }, duration);
    
    // Return function to manually remove
    return () => {
      toast.classList.remove('show');
      setTimeout(() => {
        if (toast.parentNode === container) {
          container.removeChild(toast);
        }
      }, 300);
    };
  }
  
  static success(message, duration = 3000) {
    return this.showToast(message, 'success', duration);
  }
  
  static error(message, duration = 4000) {
    return this.showToast(message, 'error', duration);
  }
  
  static info(message, duration = 3000) {
    return this.showToast(message, 'info', duration);
  }
  
  static warning(message, duration = 3000) {
    return this.showToast(message, 'warning', duration);
  }

  static loginError(message = 'Invalid email or password') {
    this.error(message);
  }
  
  static loginSuccess(message = 'Login successful!') {
    this.success(message);
  }
  
  static loginInfo(message) {
    this.info(message);
  }
  
  static loginWarning(message) {
    this.warning(message);
  }
}

export default ToastService;